export default "__VITE_ASSET__BTYJpd6R__"